import axios from "axios"

export default class EmpresaService {
  async getByRazonSocialOrCif({ cif = "", razonSocial = "" }) {
    const res = await fetch(
      `https://elk.finanedi.es/indice_empresas/_search?source_content_type=application/json&source={"size":10,"sort":{"peso":"desc"},"query": {"query_string": {"default_operator" : "AND","query" : "${
        cif || razonSocial
      }*","fields": ["cif","razonsocial"]}}}`
    )
    return res.json()
  }

  getAllIndustria() {
    return axios.get("/Industria/all")
  }

  getCnaeByIndustria(industriaId: $TSMigrationFixMe) {
    return axios.get(`/Cnae/by-industria-id/${industriaId}`)
  }

  getByNif(nif: $TSMigrationFixMe) {
    return axios.get(`/Empresa/from-resources/${nif}`)
  }

  validateEmpresa(id: $TSMigrationFixMe) {
    return axios.get(`/Certification/identityid/${id}`, {
      baseURL: import.meta.env.REACT_APP_API_CERTIFICADOS,
      withCredentials: true,
    })
  }

  update({ empresa, id }: $TSMigrationFixMe) {
    return axios.put(`/Empresa/${id}`, empresa)
  }

  UpdateEmpresaCuentasContables(cuentasContables: $TSMigrationFixMe) {
    return axios.put(
      `/Empresa/configuracion/cuentas-contables`,
      cuentasContables
    )
  }
}
